import * as React from "react";
import { SVGProps } from "react";

const Cash: React.FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 40 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M25.2423 28.2045H9.32552C8.38391 28.2045 7.49661 28.1146 6.69986 27.9348C6.28338 27.8808 5.77639 27.7369 5.25126 27.539C2.84292 26.6398 0 24.4277 0 18.9243V9.66205C0 3.78099 3.40426 0.399902 9.32552 0.399902H25.2423C30.2401 0.399902 33.4632 2.77385 34.3324 7.09023C34.4954 7.88156 34.5678 8.72684 34.5678 9.66205V18.9243C34.5678 24.8413 31.1817 28.2045 25.2423 28.2045ZM9.34359 3.13364C4.88906 3.13364 2.73424 5.27378 2.73424 9.69806V18.9603C2.73424 22.1796 3.87506 24.158 6.21097 25.0392C6.57313 25.1651 6.91719 25.255 7.24313 25.3089C7.93123 25.4528 8.60117 25.5247 9.34359 25.5247H25.2604C29.7149 25.5247 31.8697 23.3846 31.8697 18.9603V9.69806C31.8697 8.94269 31.8155 8.27724 31.6887 7.66576C31.073 4.60833 28.9725 3.13364 25.2604 3.13364H9.34359Z"
      fill="#1A1C1F"
      className={props.className}
    />
    <path
      d="M30.6745 33.5999H14.7577C13.2185 33.5999 11.8423 33.3841 10.6653 32.9345C8.00345 31.9453 6.26508 29.8591 5.66753 26.8736C5.57699 26.4239 5.72189 25.9564 6.04783 25.6506C6.37377 25.3269 6.84458 25.201 7.29727 25.3089C7.89483 25.4348 8.56481 25.5067 9.32534 25.5067H25.2421C29.6967 25.5067 31.8515 23.3666 31.8515 18.9423V9.68002C31.8515 8.92466 31.7971 8.25921 31.6704 7.64772C31.5799 7.1981 31.7247 6.74849 32.0326 6.42476C32.3585 6.10104 32.8112 5.95713 33.2639 6.06504C37.6098 6.9463 40 10.1476 40 15.0755V24.3378C40 30.2368 36.6139 33.5999 30.6745 33.5999ZM8.99941 28.2044C9.57886 29.2476 10.448 29.985 11.6431 30.4167C12.5123 30.7404 13.5625 30.9022 14.7758 30.9022H30.6926C35.1471 30.9022 37.3019 28.762 37.3019 24.3378V15.0755C37.3019 12.2339 36.4146 10.3455 34.5857 9.35631C34.5857 9.46422 34.5857 9.57211 34.5857 9.68002V18.9423C34.5857 24.8233 31.1815 28.2044 25.2602 28.2044H9.34341C9.21666 28.2044 9.10806 28.2044 8.99941 28.2044Z"
      fill="#1A1C1F"
      className={props.className}
    />
    <path
      d="M17.2924 20.4171C13.9062 20.4171 11.1538 17.6834 11.1538 14.3202C11.1538 10.957 13.9062 8.22328 17.2924 8.22328C20.6786 8.22328 23.431 10.957 23.431 14.3202C23.431 17.6834 20.6786 20.4171 17.2924 20.4171ZM17.2924 10.921C15.4092 10.921 13.87 12.4498 13.87 14.3202C13.87 16.1906 15.4092 17.7194 17.2924 17.7194C19.1756 17.7194 20.7148 16.1906 20.7148 14.3202C20.7148 12.4498 19.1756 10.921 17.2924 10.921Z"
      fill="#1A1C1F"
      className={props.className}
    />
    <path
      d="M6.93544 19.6259C6.19302 19.6259 5.57735 19.0144 5.57735 18.277V10.3636C5.57735 9.62622 6.19302 9.01473 6.93544 9.01473C7.67786 9.01473 8.29353 9.62622 8.29353 10.3636V18.277C8.29353 19.0144 7.69597 19.6259 6.93544 19.6259Z"
      fill="#1A1C1F"
      className={props.className}
    />
    <path
      d="M27.6321 19.6259C26.8897 19.6259 26.274 19.0144 26.274 18.277V10.3636C26.274 9.62622 26.8897 9.01473 27.6321 9.01473C28.3745 9.01473 28.9902 9.62622 28.9902 10.3636V18.277C28.9902 19.0144 28.3926 19.6259 27.6321 19.6259Z"
      fill="#1A1C1F"
      className={props.className}
    />
  </svg>
);

export default Cash;
